import type { CollectionSummaryProps } from "./types";
import styles from "./ToolPage.module.css";
export function CollectionSummary({
  items,
  scope,
  scopeLabel,
  details,
}: CollectionSummaryProps) {
  return (
    <div className={styles.summary}>
      <p>
        {items.map((item, i) => (
          <span key={item.label}>
            {i > 0 && " · "}
            <strong>
              {item.value === null ? "—" : item.value.toLocaleString()}
            </strong>{" "}
            {item.label}
          </span>
        ))}
        {scope === "limited" && (
          <span> · {scopeLabel || "Recent results"}</span>
        )}
      </p>
      {details && (
        <details>
          <summary>Summary</summary>
          {details}
        </details>
      )}
    </div>
  );
}
